export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[92vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20romantic%20anime%20scene%20of%20a%20boy%20and%20girl%20sharing%20an%20umbrella%20on%20a%20campus%20under%20cherry%20blossoms%20at%20sunset%2C%20warm%20rose%20gold%20and%20peach%20palette%2C%20soft%20dreamy%20illustration%2C%20gentle%20glow%2C%20expressive%20artistic%20style%2C%20no%20text&width=1600&height=900&seq=hero-anime-bg&orientation=landscape"
          alt="恋爱后宫动漫漫画推荐聚合站首屏"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-24 text-center md:px-6">
        <span className="mx-auto mb-6 inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm text-background-50 backdrop-blur-sm">
          <i className="ri-heart-fill text-accent-400" />
          恋爱 · 后宫 · 同居 · 逆后宫 一站聚合
        </span>
        <h1 className="font-heading mx-auto mb-6 max-w-3xl text-3xl font-black leading-tight text-background-50 md:text-5xl">
          羞羞动漫漫画<span className="text-gradient-warm">恋爱后宫</span>精选合集
        </h1>
        <p className="mx-auto mb-8 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
          从校园青涩心动、同居屋顶月光，到暧昧拉扯与逆后宫抉择，
          我们按剧情类型整理海量恋爱后宫作品，帮你快速找到下一部心仪的漫画。
        </p>
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#featured"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始探索
            <i className="ri-arrow-right-line" />
          </a>
          <a
            href="#ranking"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
          >
            查看排行榜
            <i className="ri-trophy-line" />
          </a>
        </div>

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-3 gap-4">
          {[
            { num: '500+', label: '精选作品' },
            { num: '4 大', label: '热门分类' },
            { num: '24h', label: '持续更新' },
          ].map((item) => (
            <div
              key={item.label}
              className="rounded-lg border border-background-50/20 bg-background-50/10 px-3 py-4 backdrop-blur-sm"
            >
              <dt className="text-xs text-background-200">{item.label}</dt>
              <dd className="font-heading mt-1 text-2xl font-bold text-background-50 md:text-3xl">
                {item.num}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}